import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=55f804de&"
import script from "./SimpleForm.vue?vue&type=script&lang=js&"
export * from "./SimpleForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports